import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const CustomerContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("eu_customer_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const res = await axios.get(`${API}/customer/me`, { headers: { Authorization: `Bearer ${token}` } });
        setCustomer(res.data);
      } catch {
        localStorage.removeItem("eu_customer_token");
        setToken(null);
      }
      setLoading(false);
    };
    check();
  }, [token]);

  const register = async (payload) => {
    const res = await axios.post(`${API}/customer/register`, payload);
    localStorage.setItem("eu_customer_token", res.data.token);
    setToken(res.data.token);
    setCustomer(res.data.customer);
    return res.data;
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/customer/login`, { email, password });
    localStorage.setItem("eu_customer_token", res.data.token);
    setToken(res.data.token);
    setCustomer(res.data.customer);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("eu_customer_token");
    setToken(null);
    setCustomer(null);
  };

  const requestSample = async (shipping) => {
    const res = await axios.post(`${API}/customer/sample-request`, shipping, { headers: { Authorization: `Bearer ${token}` } });
    setCustomer({ ...customer, sample_requested: true });
    return res.data;
  };

  return (
    <CustomerContext.Provider value={{ customer, token, loading, register, login, logout, requestSample }}>
      {children}
    </CustomerContext.Provider>
  );
}

export const useCustomer = () => useContext(CustomerContext);
